import React, {useCallback, useLayoutEffect} from "react";
import {unstable_usePrompt} from "react-router-dom";

export const Prompt = ({
                           active = true,
                           message
                       }) => {
    unstable_usePrompt({
        when: active,
        message: message
    });

    const handler = useCallback(
        (e) => {
            if (e && "preventDefault" in e) {
                if (message || active) {
                    e.preventDefault();
                }
                e.returnValue = message || active;
                return message || active;
            }
        },
        [message, active]
    );

    useLayoutEffect(() => {
        if (active) {
            window.addEventListener("beforeunload", handler);
        } else {
            window.removeEventListener("beforeunload", handler);
        }

        return () => {
            window.removeEventListener("beforeunload", handler);
        };
    }, [active, handler]);

    return <></>;
};
